// extracted by mini-css-extract-plugin
module.exports = {"title":"DashboardAllSkeleton__title__1MCIr","card":"DashboardAllSkeleton__card__25Zkn"};